import {
  CustomerAccount,
  CustomerSubAccount,
  UnifiedUserLocationRow,
} from '../types'

export function transformToUnifiedData(
  accounts: CustomerAccount[],
  locations: CustomerSubAccount[]
): UnifiedUserLocationRow[] {
  const result: UnifiedUserLocationRow[] = []

  // First, add super users (accounts without location)
  const superUsers = accounts.filter(account => !account.customerSubAccountId)
  superUsers.forEach(account => {
    result.push({
      type: 'super-user',
      id: account.id,
      email: account.email,
      name: account.name,
      createdAt: account.createdAt,
      notes: account.notes,
      customerId: account.customerId,
      customerSubAccountId: account.customerSubAccountId,
      originalAccount: account,
      status: account.status,
    })
  })

  // Then, add locations with their users
  locations.forEach(location => {
    // Add users for this location
    const locationUsers = accounts.filter(
      account => account.customerSubAccountId === Number(location.id)
    )

    // Add location header
    result.push({
      type: 'location-header',
      locationId: location.id,
      locationName: location.name || undefined,
      locationUserCount: locationUsers.length,
      locationCreatedAt: location.createdAt,
      originalLocation: {
        id: location.id,
        name: location.name || '',
        createdAt: location.createdAt,
        _count: { customerAccounts: locationUsers.length },
      },
    })

    locationUsers.forEach(account => {
      result.push({
        type: 'location-user',
        id: account.id,
        email: account.email,
        name: account.name,
        createdAt: account.createdAt,
        notes: account.notes,
        customerId: account.customerId,
        customerSubAccountId: account.customerSubAccountId,
        locationId: location.id,
        locationName: location.name || undefined,
        originalAccount: account,
        status: account.status,
      })
    })
  })

  return result
}
